import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import { LabelField } from "components/LabelField";
import InfoTooltip from "components/InfoTooltip";
import { MenuSingleCheckBox } from "components/MenuSingleCheckBox/MenuSingleCheckBox";
import React, { useEffect, useState } from 'react';

const LedgerList = ({formik,type}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [ledgers, setLedgers] = useState([]);
  useEffect(() => {
    async function getLedgeraccounts() {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = [...res?.ledgers];
        setLedgers(arrayWithSelectAll);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <LabelField title={"Ledger Account"} />
        <InfoTooltip text="The ledger account the collected convenience fee gets booked to." style={{ marginTop: '-10px' }} />
      </div>
      <MenuSingleCheckBox
        Items={ledgers}
        withBorder={true}
        onLedgerAccountChange={(ledger) => {
          formik.setFieldValue("convenienceFeeInfo.ledger", {
            id: ledger._id,
            name: ledger.ledger_name,
          });
          if (formik.values?.convenienceFeeInfo?.ledger?.id !== ledger._id) {
            formik.setFieldValue("convenienceFeeInfo.subLedger", {
              id: "",
              name: "",
            });
          }
        }}
        onSubLedgerAccountChange={(subLedger) => {
          formik.setFieldValue("convenienceFeeInfo.subLedger",  {
            id: subLedger._id,
            name: subLedger.sub_ledger_name,
          });
        }}
        activeLedger={formik.values?.convenienceFeeInfo?.ledger}
        activeSubLedger={formik.values?.convenienceFeeInfo?.subLedger}
        disabled={type === "view"}
      />
    </div>
  )
}

export default LedgerList